import React from "react";
export const SVG_Business = () => {
  return (
    <svg
      className="mx-auto"
      xmlns="https://www.w3.org/2000/svg"
      width="34.001"
      height="34"
      viewBox="0 0 34.001 34"
    >
      <path
        fill="#c4c4c4"
        d="M25.3 5.3h-5a4.13 4.13 0 01-3.22-1.508l-1.647-2.283A4.024 4.024 0 0012.228 0H8.691C2.343 0 0 3.726 0 10.062v6.848c-.008.753 33.992.752 33.994 0v-1.991C34.025 8.584 31.742 5.3 25.3 5.3z"
        data-name="Folder 2"
        opacity="0.4"
      ></path>
      <path
        fill="#c4c4c4"
        d="M24.423 28.732c-.175 0-.352 0-.526-.014H10.083c-.173.009-.348.013-.521.013a10.229 10.229 0 01-6.916-2.683 7.628 7.628 0 01-1.134-1.508 9.864 9.864 0 01-1.33-3.712A13.851 13.851 0 010 18.58V9.651a20.644 20.644 0 01.121-2.233c.017-.129.043-.257.067-.38a3.22 3.22 0 00.084-.629A9.552 9.552 0 011.1 3.828C2.3 1.27 4.773.026 8.661.026h16.627c.227-.017.457-.026.684-.026a8.91 8.91 0 015.484 1.9 4.725 4.725 0 01.56.558 6.689 6.689 0 011.239 2.157 14.467 14.467 0 01.74 5.038v8.927a16.05 16.05 0 01-.167 2.248 10.134 10.134 0 01-1.36 3.712 7.557 7.557 0 01-1.149 1.509 10.171 10.171 0 01-6.896 2.683zM8.45 14.945a1.4 1.4 0 100 2.806h17.203a1.4 1.4 0 001.4-1.359 1.262 1.262 0 00-.3-.906 1.34 1.34 0 00-1.059-.543z"
        data-name="Folder"
        transform="translate(0 5.268)"
      ></path>
    </svg>
  );
};

export const SVG_TICK = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="w-6 h-6 inline-block"
      viewBox="0 0 16 16"
    >
      <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
    </svg>
  );
};
export const SVG_PLUS = ({ color }) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill={color}
      className={`inline-block w-4 h-4 text-${color}`}
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
    >
      <path d="M9.9968 8.0396h6.0302c.5374 0 .973.4356.973.973s-.4356.973-.973.973H9.9968V16c0 .5523-.4477 1-1 1h-.023c-.5523 0-1-.4477-1-1V9.9884H1.9744C1.4363 9.9884 1 9.5521 1 9.014s.4363-.9744.9744-.9744h5.9994V2c0-.5523.4477-1 1-1h.0244c.5523 0 1 .4477 1 1v6.0396h-.0014z"></path>
    </svg>
  );
};

export const SVG_Back = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="63.496"
      height="22"
      viewBox="0 0 63.496 22"
    >
      <g data-name="Group 11" transform="translate(1 1)">
        <text
          fill="#c4c4c4"
          data-name="Phone Number"
          transform="translate(26.496 14)"
        >
          <tspan x="0" y="0">
            Back
          </tspan>
        </text>
        <g fill="none" stroke="#c4c4c4">
          <path
            d="M0 .5h13.017"
            data-name="Stroke 1"
            transform="translate(5.336 9.5)"
          ></path>
          <path
            d="M3.165 0L0 3.152 3.165 6.3"
            data-name="Stroke 3"
            transform="translate(5.336 6.847)"
          ></path>
          <path
            d="M13.237 4.991V3.983A3.982 3.982 0 009.253 0h-5.28A3.972 3.972 0 000 3.973v12.043A3.984 3.984 0 003.984 20h5.281a3.973 3.973 0 003.972-3.973v-1.018"
            data-name="Stroke 4"
            opacity="0.4"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const SVG_Menu_Register = () => {
  return (
    <svg
      className="mx-auto"
      xmlns="http://www.w3.org/2000/svg"
      width="21.5"
      height="21.5"
      viewBox="0 0 21.5 21.5"
    >
      <g data-name="Iconly/Two-tone/Chart" transform="translate(.75 .75)">
        <g fill="none" stroke="#fff" transform="rotate(90 10 10)">
          <path
            d="M0 10.143V0"
            opacity="0.4"
            transform="translate(5.371 4.938)"
          ></path>
          <path
            d="M0 10.143V0"
            opacity="0.4"
            transform="translate(10.038 4.938)"
          ></path>
          <path
            d="M0 10.143V0"
            opacity="0.4"
            transform="translate(14.629 4.938)"
          ></path>
          <path d="M14.686 20H5.314C2.048 20 0 17.688 0 14.415v-8.83C0 2.312 2.038 0 5.314 0h9.371C17.962 0 20 2.312 20 5.585v8.83C20 17.688 17.962 20 14.686 20z"></path>
        </g>
      </g>
    </svg>
  );
};

export const SVG_Location_Register = () => {
  return (
    <svg
      className="mx-auto"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      data-name="Iconly/Two-tone/Location"
      viewBox="0 0 24 24"
    >
      <g fill="none" stroke="#989898" transform="translate(3.5 2)">
        <path
          d="M0 7.652a7.678 7.678 0 1115.357.048v.087a11.338 11.338 0 01-3.478 7.3 20.183 20.183 0 01-3.591 2.957.93.93 0 01-1.217 0 19.817 19.817 0 01-5.052-4.73A9.826 9.826 0 010 7.678z"
          transform="translate(.739 .739)"
        ></path>
        <circle
          cx="2.461"
          cy="2.461"
          r="2.461"
          opacity="0.4"
          transform="translate(5.957 6.078)"
        ></circle>
      </g>
    </svg>
  );
};

export const SVG_Working_Hours_Register = () => {
  return (
    <svg
      className="mx-auto"
      xmlns="https://www.w3.org/2000/svg"
      width="21.5"
      height="21.5"
      viewBox="0 0 21.5 21.5"
    >
      <g data-name="Iconly/Two-tone/Chart" transform="translate(.75 .75)">
        <g fill="none" stroke="#fff" transform="rotate(90 10 10)">
          <path
            d="M0 10.143V0"
            opacity="0.4"
            transform="translate(5.371 4.938)"
          ></path>
          <path
            d="M0 10.143V0"
            opacity="0.4"
            transform="translate(10.038 4.938)"
          ></path>
          <path
            d="M0 10.143V0"
            opacity="0.4"
            transform="translate(14.629 4.938)"
          ></path>
          <path d="M14.686 20H5.314C2.048 20 0 17.688 0 14.415v-8.83C0 2.312 2.038 0 5.314 0h9.371C17.962 0 20 2.312 20 5.585v8.83C20 17.688 17.962 20 14.686 20z"></path>
        </g>
      </g>
    </svg>
  );
};

// export const SVG_Location_Register = () => {
//   return (
//     <svg
//       className="mx-auto"
//       xmlns="https://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       data-name="Iconly/Two-tone/Location"
//       viewBox="0 0 24 24"
//     >
//       <g fill="none" stroke="#989898" transform="translate(3.5 2)">
//         <path
//           d="M0 7.652a7.678 7.678 0 1115.357.048v.087a11.338 11.338 0 01-3.478 7.3 20.183 20.183 0 01-3.591 2.957.93.93 0 01-1.217 0 19.817 19.817 0 01-5.052-4.73A9.826 9.826 0 010 7.678z"
//           transform="translate(.739 .739)"
//         ></path>
//         <circle
//           cx="2.461"
//           cy="2.461"
//           r="2.461"
//           opacity="0.4"
//           transform="translate(5.957 6.078)"
//         ></circle>
//       </g>
//     </svg>
//   );
// };

// export const SVG_Working_Hours_Register = () => {
//   return (
//     <svg
//       className="mx-auto"
//       xmlns="https://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       data-name="Iconly/Two-tone/Calendar"
//       viewBox="0 0 24 24"
//     >
//       <g
//         fill="none"
//         stroke="#989898"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         strokeMiterlimit="10"
//         strokeWidth="1.5"
//         transform="translate(3 2)"
//       >
//         <path d="M.093 7.404h17.824" opacity="0.4"></path>
//         <path
//           d="M13.442 15.197h.009zm-4.438 0h.01zm-4.446 0h.009zm8.884-3.887h.009zm-4.438 0h.01zm-4.446 0h.009z"
//           data-name="Combined Shape"
//           opacity="0.4"
//         ></path>
//         <path d="M13.044 0v3.291"></path>
//         <path d="M4.965 0v3.291"></path>
//         <path d="M13.238 1.579H4.771C1.834 1.579 0 3.215 0 6.222v9.05C0 18.326 1.834 20 4.771 20h8.458C16.175 20 18 18.355 18 15.348V6.222c.009-3.007-1.816-4.643-4.762-4.643z"></path>
//       </g>
//     </svg>
//   );
// };

export const SVG_Payment_Register = () => {
  return (
    <svg
      className="mx-auto"
      xmlns="https://www.w3.org/2000/svg"
      width="24"
      height="24"
      data-name="Iconly/Two-tone/Wallet"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        stroke="#989898"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        transform="translate(2.5 3)"
      >
        <path
          d="M19.138 11.396H15.09a2.692 2.692 0 110-5.383h4.048"
          data-name="Stroke 1"
        ></path>
        <path d="M15.549 8.643h-.312" data-name="Stroke 3"></path>
        <path
          d="M5.248 0h8.643a5.248 5.248 0 015.248 5.248v7.177a5.248 5.248 0 01-5.248 5.248H5.248A5.248 5.248 0 010 12.425V5.248A5.248 5.248 0 015.248 0z"
          data-name="Stroke 5"
        ></path>
        <path d="M4.536 4.538h5.4" data-name="Stroke 7" opacity="0.4"></path>
      </g>
    </svg>
  );
};

export const SVG_Location_White_Register = () => {
  return (
    <svg
      className="mx-auto"
      xmlns="https://www.w3.org/2000/svg"
      width="24"
      height="24"
      data-name="Iconly/Two-tone/Location"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        transform="translate(3.5 2)"
      >
        <path d="M.739 8.391a7.679 7.679 0 1115.357.048v.087a11.338 11.338 0 01-3.478 7.3 20.183 20.183 0 01-3.591 2.957.93.93 0 01-1.217 0 19.817 19.817 0 01-5.052-4.73A9.826 9.826 0 01.739 8.417z"></path>
        <circle
          cx="2.461"
          cy="2.461"
          r="2.461"
          opacity="0.4"
          transform="translate(5.957 6.078)"
        ></circle>
      </g>
    </svg>
  );
};

export const SVG_Working_Hours_White_Register = () => {
  return (
    <svg
      className="mx-auto"
      xmlns="https://www.w3.org/2000/svg"
      width="19.5"
      height="21.5"
      viewBox="0 0 19.5 21.5"
    >
      <g
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        transform="translate(.75 .75)"
      >
        <path d="M.093 7.404h17.824" opacity="0.4"></path>
        <path
          d="M13.442 15.197h.009zm-4.438 0h.01zm-4.446 0h.009zm8.884-3.887h.009zm-4.438 0h.01zm-4.446 0h.009z"
          data-name="Combined Shape"
          opacity="0.4"
        ></path>
        <path d="M13.044 0v3.291"></path>
        <path d="M4.965 0v3.291"></path>
        <path d="M13.238 1.579H4.771C1.834 1.579 0 3.215 0 6.222v9.05C0 18.326 1.834 20 4.771 20h8.458C16.175 20 18 18.355 18 15.348V6.222c.009-3.007-1.816-4.643-4.762-4.643z"></path>
      </g>
    </svg>
  );
};

export const SVG_Payment_White_Register = () => {
  return (
    <svg
      className="mx-auto"
      xmlns="https://www.w3.org/2000/svg"
      width="24"
      height="24"
      data-name="Iconly/Two-tone/Wallet"
      viewBox="0 0 24 24"
    >
      <g
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
        transform="translate(2.5 3)"
      >
        <path
          d="M19.138 11.396H15.09a2.692 2.692 0 110-5.383h4.048"
          data-name="Stroke 1"
        ></path>
        <path d="M15.549 8.643h-.312" data-name="Stroke 3"></path>
        <path
          d="M5.248 0h8.643a5.248 5.248 0 015.248 5.248v7.177a5.248 5.248 0 01-5.248 5.248H5.248A5.248 5.248 0 010 12.425V5.248A5.248 5.248 0 015.248 0z"
          data-name="Stroke 5"
        ></path>
        <path d="M4.536 4.538h5.4" data-name="Stroke 7" opacity="0.4"></path>
      </g>
    </svg>
  );
};

export const SVG_Edit = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="20"
      height="20"
      data-name="Edit Square"
      viewBox="0 0 20 20"
    >
      <path
        fill="#4e4e4e"
        d="M14.664 19.99H5.335A5.343 5.343 0 011.4 18.6a5.346 5.346 0 01-1.39-3.935v-9.33A5.345 5.345 0 011.4 1.4 5.347 5.347 0 015.335.01h9.329A5.338 5.338 0 0118.6 1.4a5.372 5.372 0 011.39 3.935v9.33A5.35 5.35 0 0118.6 18.6a5.347 5.347 0 01-3.937 1.389"
        data-name="Fill 1"
        opacity="0.4"
      ></path>
      <path
        fill="#4e4e4e"
        d="M10.555 3.9L4 10.483A1.8 1.8 0 012.746 11H.458a.463.463 0 01-.331-.137.457.457 0 01-.127-.331L.058 8.22a1.759 1.759 0 01.516-1.21l4.645-4.654a.211.211 0 01.292 0L7.14 3.979a.615.615 0 00.428.176.643.643 0 00.643-.644.661.661 0 00-.175-.449c-.029-.039-1.58-1.583-1.58-1.583a.26.26 0 010-.361l.652-.664a1.538 1.538 0 012.181 0l1.266 1.268a1.551 1.551 0 010 2.176"
        data-name="Fill 4"
        transform="translate(4.5 4.5)"
      ></path>
    </svg>
  );
};

export const SVG_Delete = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 18 20"
    >
      <path
        fill="#e60019"
        d="M15.289.792c0 .068-.533 6.809-.837 9.646a2.918 2.918 0 01-3 2.827c-1.293.029-2.56.039-3.806.039-1.323 0-2.616-.01-3.872-.039a2.917 2.917 0 01-2.927-2.827C.534 7.591.011.86 0 .792A.794.794 0 01.192.234.71.71 0 01.715 0h13.87a.73.73 0 01.523.234.748.748 0 01.181.558"
        data-name="Fill 1"
        opacity="0.4"
        transform="translate(1.354 6.696)"
      ></path>
      <path
        fill="#e60019"
        d="M18 3.977a.722.722 0 00-.713-.733h-2.916a1.281 1.281 0 01-1.241-1.017l-.163-.727a1.985 1.985 0 00-1.9-1.5H6.936a1.988 1.988 0 00-1.913 1.546l-.153.682a1.283 1.283 0 01-1.24 1.016H.714A.722.722 0 000 3.977v.38a.729.729 0 00.714.733h16.573A.729.729 0 0018 4.357z"
        data-name="Fill 4"
      ></path>
    </svg>
  );
};

export const SVG_Cancel = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="18"
      height="20"
      viewBox="0 0 40 40"
    >
      <path
        fill="#f78f8f"
        d="M20 38.5C9.799 38.5 1.5 30.201 1.5 20S9.799 1.5 20 1.5 38.5 9.799 38.5 20 30.201 38.5 20 38.5z"
      ></path>
      <path
        fill="#c74343"
        d="M20 2c9.925 0 18 8.075 18 18s-8.075 18-18 18S2 29.925 2 20 10.075 2 20 2m0-1C9.507 1 1 9.507 1 20s8.507 19 19 19 19-8.507 19-19S30.493 1 20 1z"
      ></path>
      <path
        fill="#fff"
        d="M13.99 28.132l-2.122-2.122 14.143-14.142 2.12 2.122z"
      ></path>
      <path
        fill="#fff"
        d="M11.868 13.99l2.121-2.122L28.132 26.01l-2.121 2.122z"
      ></path>
    </svg>
  );
};

export const SVG_Save = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#c74343" transform="translate(-139 -680)">
          <g transform="translate(56 160)">
            <path d="M90.219 525h2.1v-2h-2.1v2zM87.2 536h12.6v-2H87.2v2zm0-4h12.6v-2H87.2v2zm14.7 6H85.1v-11.163l2.1-2V528H99.8v-6h2.1v16zm-12.6-15.163l.879-.837H97.7v4h-8.4v-3.163zM103.966 520H89.3v.008L87.208 522H87.2v.008L83.008 526H83v14h21v-20h-.034z"></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SVG_Dashboard = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        fill="#c4c4c4"
        d="M2.539 0h3.385a2.549 2.549 0 012.539 2.56v3.415a2.549 2.549 0 01-2.539 2.56H2.539A2.549 2.549 0 010 5.975V2.56A2.549 2.549 0 012.539 0"
        data-name="Fill 1"
        opacity="0.4"
        transform="translate(11.537)"
      ></path>
      <path
        fill="#c4c4c4"
        d="M14.075 20a2.549 2.549 0 01-2.538-2.56v-3.414a2.549 2.549 0 012.538-2.561h3.387A2.549 2.549 0 0120 14.026v3.414A2.549 2.549 0 0117.462 20zM2.539 20A2.55 2.55 0 010 17.44v-3.414a2.55 2.55 0 012.539-2.561h3.386a2.549 2.549 0 012.538 2.561v3.414A2.549 2.549 0 015.925 20zm0-11.465A2.549 2.549 0 010 5.974V2.56A2.549 2.549 0 012.539 0h3.386a2.548 2.548 0 012.538 2.56v3.414a2.549 2.549 0 01-2.538 2.561z"
        data-name="Combined Shape"
      ></path>
    </svg>
  );
};

export const SVG_Landing_Pages = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="17"
      height="20"
      viewBox="0 0 17 20"
    >
      <path
        fill="#c4c4c4"
        d="M15.309 7.021c-.452 0-1.05-.01-1.794-.01a3.336 3.336 0 01-3.309-3.336V.459A.456.456 0 009.753 0H4.464A4.489 4.489 0 000 4.509v10.775A4.692 4.692 0 004.67 20h7.877A4.476 4.476 0 0017 15.5V7.471a.453.453 0 00-.453-.458c-.423 0-.93.008-1.239.008"
        data-name="Fill 3"
        opacity="0.4"
      ></path>
      <path
        fill="#c4c4c4"
        d="M.821.147A.477.477 0 000 .481v2.637a2.026 2.026 0 002.017 2.016c.7.008 1.665.01 2.487.008a.477.477 0 00.343-.808C3.792 3.237 1.9 1.271.821.147"
        data-name="Fill 1"
        transform="translate(11.763 .42)"
      ></path>
    </svg>
  );
};
export const SVG_Packages = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g fill="#c4c4c4">
        <path
          d="M12.662 18H5.346a5.415 5.415 0 01-3.936-1.412A5.4 5.4 0 010 12.661V5.356A5.428 5.428 0 011.41 1.42 5.4 5.4 0 015.346 0h7.967a3.909 3.909 0 00-.07.738 4.029 4.029 0 004.027 4.021 4.142 4.142 0 00.73-.07v7.972a5.405 5.405 0 01-1.409 3.927A5.4 5.4 0 0112.662 18zM7.222 7.079a.752.752 0 00-.1.006.741.741 0 00-.493.29l-2.953 3.811a.728.728 0 00-.158.457.739.739 0 001.363.43l2.47-3.2 2.743 2.152a.747.747 0 00.464.163.741.741 0 00.592-.3l2.858-3.687v-.01a.75.75 0 00-.14-1.045.73.73 0 00-1.038.149L10.42 9.4 7.677 7.235a.742.742 0 00-.455-.156z"
          transform="translate(0 2)"
        ></path>
        <circle
          cx="2.5"
          cy="2.5"
          r="2.5"
          opacity="0.4"
          transform="translate(15)"
        ></circle>
      </g>
    </svg>
  );
};

export const SVG_Ordering_Panel = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="19"
      height="20"
      viewBox="0 0 19 20"
    >
      <path
        fill="#c4c4c4"
        d="M2.9 5.65A2.853 2.853 0 010 2.83 2.861 2.861 0 012.9 0a2.825 2.825 0 110 5.65"
        transform="translate(6.61 7.18)"
      ></path>
      <path
        fill="#c4c4c4"
        d="M18.73 12.37a2.3 2.3 0 00-.828-.79 1.547 1.547 0 01-.634-.64 1.822 1.822 0 01.654-2.5 2.027 2.027 0 00.756-2.83l-.685-1.18a2.112 2.112 0 00-2.872-.76 1.973 1.973 0 01-2.575-.69 1.546 1.546 0 01-.235-.88 1.778 1.778 0 00-.276-1.06A2.152 2.152 0 0010.217 0H8.776a2.195 2.195 0 00-1.809 1.04 1.785 1.785 0 00-.286 1.06 1.546 1.546 0 01-.235.88 1.963 1.963 0 01-2.565.69A2.124 2.124 0 001 4.43L.314 5.61a2.044 2.044 0 00.756 2.83 1.834 1.834 0 01.664 2.5 1.634 1.634 0 01-.644.64 2.118 2.118 0 00-.818.79 2 2 0 00.02 2.05L1 15.62a2.134 2.134 0 001.819 1.04 2.161 2.161 0 001.083-.3 1.586 1.586 0 01.9-.23 1.892 1.892 0 011.88 1.82A2.07 2.07 0 008.807 20H10.2a2.068 2.068 0 002.115-2.05 1.908 1.908 0 011.885-1.82 1.63 1.63 0 01.9.23 2.1 2.1 0 002.892-.74l.715-1.2a2.018 2.018 0 00.02-2.05"
        data-name="Path"
        opacity="0.4"
      ></path>
    </svg>
  );
};

export const SVG_Menu = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="17"
      height="20"
      viewBox="0 0 17 20"
    >
      <path
        fill="#c4c4c4"
        d="M15.309 7.021c-.452 0-1.05-.01-1.794-.01a3.336 3.336 0 01-3.309-3.336V.459A.456.456 0 009.753 0H4.464A4.489 4.489 0 000 4.509v10.775A4.692 4.692 0 004.67 20h7.877A4.476 4.476 0 0017 15.5V7.471a.453.453 0 00-.453-.458c-.423 0-.93.008-1.239.008"
        data-name="Fill 3"
        opacity="0.4"
      ></path>
      <path
        fill="#c4c4c4"
        d="M.821.147A.477.477 0 000 .481v2.637a2.026 2.026 0 002.017 2.016c.7.008 1.665.01 2.487.008a.477.477 0 00.343-.808C3.792 3.237 1.9 1.271.821.147"
        data-name="Fill 1"
        opacity="0.4"
        transform="translate(11.763 .42)"
      ></path>
      <path
        fill="#c4c4c4"
        d="M.744 6.484a.745.745 0 010-1.49h5.444a.745.745 0 010 1.49zm0-5A.744.744 0 11.744 0h3.385a.744.744 0 110 1.489z"
        data-name="Combined Shape"
        transform="translate(4.73 7.899)"
      ></path>
    </svg>
  );
};

export const SVG_User_Roles = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="22"
      height="16"
      data-name="3 User"
      viewBox="0 0 22 16"
    >
      <path
        fill="#c4c4c4"
        d="M6.361 0C2.911 0 0 .564 0 2.739S2.93 5.46 6.361 5.46c3.45 0 6.361-.564 6.361-2.739S9.792 0 6.361 0"
        data-name="Fill 1"
        transform="translate(4.588 10.54)"
      ></path>
      <path
        fill="#c4c4c4"
        d="M4.209 8.467a4.207 4.207 0 004.21-4.233 4.209 4.209 0 10-8.419 0 4.207 4.207 0 004.209 4.233"
        data-name="Fill 3"
        opacity="0.4"
        transform="translate(6.74)"
      ></path>
      <path
        fill="#c4c4c4"
        d="M4.225 4.513A3.574 3.574 0 00.8 0a3.587 3.587 0 00-.708.073.136.136 0 00-.082.049.1.1 0 00.017.11A5.807 5.807 0 011.094 3.6 5.762 5.762 0 01.11 6.844a.158.158 0 00.107.244 3.282 3.282 0 00.483.047 3.513 3.513 0 003.525-2.622"
        data-name="Fill 6"
        opacity="0.4"
        transform="translate(15.863 .707)"
      ></path>
      <path
        fill="#c4c4c4"
        d="M5.407 1.59A2.755 2.755 0 003.276.286 15.555 15.555 0 00.033 0 .037.037 0 000 .027a.046.046 0 00.029.048 4.451 4.451 0 012.655 4.381.181.181 0 00.2.205c.577-.083 2.06-.4 2.521-1.4a1.922 1.922 0 000-1.67"
        data-name="Fill 8"
        transform="translate(16.402 9.227)"
      ></path>
      <path
        fill="#c4c4c4"
        d="M4.252.073A3.514 3.514 0 003.543 0 3.573 3.573 0 00.12 4.513a3.511 3.511 0 003.524 2.622 3.4 3.4 0 00.484-.047.158.158 0 00.107-.244A5.841 5.841 0 014.318.232a.1.1 0 00.016-.11.129.129 0 00-.082-.05"
        data-name="Fill 11"
        opacity="0.4"
        transform="translate(1.793 .707)"
      ></path>
      <path
        fill="#c4c4c4"
        d="M2.322.285a2.753 2.753 0 00-2.13 1.3 1.918 1.918 0 000 1.671c.46 1 1.944 1.319 2.521 1.4a.18.18 0 00.2-.205A4.45 4.45 0 015.569.075.047.047 0 005.6.027.034.034 0 005.566 0a15.517 15.517 0 00-3.244.285"
        data-name="Fill 13"
        transform="translate(0 9.228)"
      ></path>
    </svg>
  );
};

export const SVG_Manage_Orders = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="20.015"
      height="19.599"
      viewBox="0 0 20.015 19.599"
    >
      <g fill="#c4c4c4">
        <path
          d="M11.25 1.52a1.515 1.515 0 111.52 1.51 1.52 1.52 0 01-1.52-1.51zM0 1.52a1.515 1.515 0 111.52 1.51A1.52 1.52 0 010 1.52z"
          data-name="Combined Shape"
          opacity="0.4"
          transform="translate(3.911 16.569)"
        ></path>
        <path
          d="M16.5 14.989H5.591a2.549 2.549 0 01-2.54-2.339L2.13 1.749l-1.509-.26a.747.747 0 01-.481-.308.732.732 0 01-.129-.553A.761.761 0 01.768 0a.793.793 0 01.113.008l2.385.36a.759.759 0 01.619.68l.191 2.24a.612.612 0 00.609.561h13.506a1.706 1.706 0 011.41.67 2.169 2.169 0 01.38 1.719l-.95 6.56a2.566 2.566 0 01-2.531 2.191zm-4.37-7.44a.742.742 0 00-.751.75.751.751 0 00.751.751h2.77a.751.751 0 00.751-.751.742.742 0 00-.751-.75z"
          data-name="Fill 7"
        ></path>
      </g>
    </svg>
  );
};

export const FLAG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className="h-8 w-8 text-blue-500"
      viewBox="0 0 16 16"
    >
      <path d="M14.778.085A.5.5 0 0 1 15 .5V8a.5.5 0 0 1-.314.464L14.5 8l.186.464-.003.001-.006.003-.023.009a12.435 12.435 0 0 1-.397.15c-.264.095-.631.223-1.047.35-.816.252-1.879.523-2.71.523-.847 0-1.548-.28-2.158-.525l-.028-.01C7.68 8.71 7.14 8.5 6.5 8.5c-.7 0-1.638.23-2.437.477A19.626 19.626 0 0 0 3 9.342V15.5a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 1 0v.282c.226-.079.496-.17.79-.26C4.606.272 5.67 0 6.5 0c.84 0 1.524.277 2.121.519l.043.018C9.286.788 9.828 1 10.5 1c.7 0 1.638-.23 2.437-.477a19.587 19.587 0 0 0 1.349-.476l.019-.007.004-.002h.001M14 1.221c-.22.078-.48.167-.766.255-.81.252-1.872.523-2.734.523-.886 0-1.592-.286-2.203-.534l-.008-.003C7.662 1.21 7.139 1 6.5 1c-.669 0-1.606.229-2.415.478A21.294 21.294 0 0 0 3 1.845v6.433c.22-.078.48-.167.766-.255C4.576 7.77 5.638 7.5 6.5 7.5c.847 0 1.548.28 2.158.525l.028.01C9.32 8.29 9.86 8.5 10.5 8.5c.668 0 1.606-.229 2.415-.478A21.317 21.317 0 0 0 14 7.655V1.222z" />
    </svg>
  );
};

export const CITY = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className="h-8 w-8 text-blue-500"
      viewBox="0 0 16 16"
    >
      <path d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022ZM6 8.694 1 10.36V15h5V8.694ZM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15Z" />
      <path d="M2 11h1v1H2v-1Zm2 0h1v1H4v-1Zm-2 2h1v1H2v-1Zm2 0h1v1H4v-1Zm4-4h1v1H8V9Zm2 0h1v1h-1V9Zm-2 2h1v1H8v-1Zm2 0h1v1h-1v-1Zm2-2h1v1h-1V9Zm0 2h1v1h-1v-1ZM8 7h1v1H8V7Zm2 0h1v1h-1V7Zm2 0h1v1h-1V7ZM8 5h1v1H8V5Zm2 0h1v1h-1V5Zm2 0h1v1h-1V5Zm0-2h1v1h-1V3Z" />
    </svg>
  );
};
export const MAP = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className="h-8 w-8 text-green-500"
      viewBox="0 0 16 16"
    >
      <path d="M8 0a8 8 0 0 1 8 8c0 3.775-2.348 6.958-5.667 8.281a1 1 0 0 1-1.333 0C2.348 14.958 0 11.775 0 8a8 8 0 0 1 8-8zm0 14a6 6 0 0 0 0-12V2.747a6 6 0 0 0-1.5.404V3.5a1 1 0 0 0 2 0v-.553A6 6 0 0 0 8 2a6 6 0 0 0 0 12zm0-10a4 4 0 0 0-4 4 4 4 0 0 0 1.063 2.75 1 1 0 0 0 1.437 0A4 4 0 0 0 8 6a4 4 0 0 0 0-8zm0 1a3 3 0 0 1 2.824 2h-1.116A2 2 0 0 0 8 3a2 2 0 0 0-2 2 2 2 0 0 0 .293 1h-1.117A3 3 0 0 1 8 2zm-1.117-1h2.234A3.001 3.001 0 0 1 6.883 1zM8 14c2.04 0 3.91-.692 5.408-1.847.24-.194.442-.408.592-.643a7.96 7.96 0 0 1-2.787-1.94 5.001 5.001 0 0 1-1.105-1.672A4.001 4.001 0 0 0 8 12a4 4 0 0 0 0-8 4.001 4.001 0 0 0-3.717 5.425 7.957 7.957 0 0 1-2.787 1.94c.15.235.352.449.592.643C4.09 13.308 5.96 14 8 14z" />
    </svg>
  );
};

export const AREA = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className="h-8 w-8 text-blue-500"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8l3-4z"
      />
      <path
        fillRule="evenodd"
        d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"
      />
    </svg>
  );
};
export const SVG_Sign_off = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <path
        fill="#c4c4c4"
        d="M14 4.447A4.492 4.492 0 009.475 0H4.514A4.481 4.481 0 000 4.437v11.116A4.492 4.492 0 004.526 20h4.959A4.481 4.481 0 0014 15.563V4.447z"
        data-name="Fill 1"
        opacity="0.4"
        transform="translate(6)"
      ></path>
      <path
        fill="#c4c4c4"
        d="M.221 3.134L3.067.225a.736.736 0 011.061 0 .785.785 0 010 1.089L2.566 2.909h9.885a.77.77 0 010 1.54H2.566l1.56 1.593a.785.785 0 010 1.089.735.735 0 01-1.061 0L.221 4.225a.784.784 0 010-1.091"
        data-name="Fill 3"
        transform="translate(0 6.321)"
      ></path>
    </svg>
  );
};

export const SVG_Pause_Orders = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 48 48"
    >
      <path fill="none" d="M0 0h48v48H0z"></path>
      <path
        fill="#c4c4c4"
        d="M18 32h4V16h-4v16zm6-28C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm2-8h4V16h-4v16z"
      ></path>
    </svg>
  );
};

export const AngleUpIcon = () => (
  <svg
    fill="#6B7280"
    strokeWidth="0"
    viewBox="0 0 320 512"
    xmlns="https://www.w3.org/2000/svg"
    className="h-4"
  >
    <path d="M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z" />
  </svg>
);

export const AngleDownIcon = () => (
  <svg
    stroke="currentColor"
    fill="#6B7280"
    strokeWidth="0"
    viewBox="0 0 320 512"
    xmlns="https://www.w3.org/2000/svg"
    className="h-4"
  >
    <path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z" />
  </svg>
);

export const SVG_DELETE_DIALOG = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      fill="currentColor"
      className="w-16 h-16 flex items-center text-red-500 mx-auto"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export const SVG_RIGHT_ARROW = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="24"
      height="24"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#c4c4c4"
      className="mx-auto"
    >
      <path d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12S0 18.623 0 12 5.377 0 12 0zm0 1c6.071 0 11 4.929 11 11s-4.929 11-11 11S1 18.071 1 12 5.929 1 12 1zM9 6.753L15.44 12 9 17.263l.678.737L17 12 9.665 6 9 6.753z"></path>
    </svg>
  );
};

export const SVG_THREE_DOT_VERTICAL = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="#6B7280"
      className="bi bi-three-dots-vertical"
      viewBox="0 0 16 16"
    >
      <path d="M9.5 13a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0-5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm0-5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"></path>
    </svg>
  );
};

export const SVG_VIEW_EYE = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="#6B7280"
    >
      <path d="M14 12c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2zm10-.449S19.748 19 12.015 19C4.835 19 0 11.551 0 11.551S4.446 5 12.015 5C19.709 5 24 11.551 24 11.551zM16 12a4 4 0 10-8.002.002A4 4 0 0016 12z"></path>
    </svg>
  );
};

export const SVG_DELETE_SMALL = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="16"
      height="16"
      baseProfile="tiny"
      version="1.2"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
      fill="#6B7280"
    >
      <path d="M12 4c-4.419 0-8 3.582-8 8s3.581 8 8 8 8-3.582 8-8-3.581-8-8-8zm3.707 10.293a.999.999 0 11-1.414 1.414L12 13.414l-2.293 2.293a.997.997 0 01-1.414 0 .999.999 0 010-1.414L10.586 12 8.293 9.707a.999.999 0 111.414-1.414L12 10.586l2.293-2.293a.999.999 0 111.414 1.414L13.414 12l2.293 2.293z"></path>
    </svg>
  );
};

export const SVG_EDIT_SMALL = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 18 18"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-579 -2771)">
          <g transform="translate(100 2626)">
            <g transform="translate(476 142)">
              <path d="M0 0L24 0 24 24 0 24z"></path>
              <path
                fill="#6B7280"
                d="M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SVG_OPTIONS = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      x="0"
      y="0"
      width="34.001"
      height="34"
      enableBackground="new 0 0 291.006 291.006"
      version="1.1"
      viewBox="0 0 291.006 291.006"
      xmlSpace="preserve"
    >
      <g fill="#010002">
        <path d="M57.377 0c-24.59 0-44.6 20.01-44.6 44.606s20.01 44.611 44.6 44.611H233.63c24.59 0 44.6-20.01 44.6-44.611C278.23 20.01 258.22 0 233.63 0H57.377zm209.975 44.6c0 18.596-15.126 33.733-33.722 33.733H57.377c-18.596 0-33.722-15.131-33.722-33.733 0-18.596 15.126-33.728 33.722-33.728H233.63c18.596.006 33.722 15.132 33.722 33.728zM233.63 100.895H57.377c-24.59 0-44.6 20.01-44.6 44.606s20.01 44.611 44.6 44.611H233.63c24.59 0 44.6-20.01 44.6-44.611 0-24.596-20.005-44.606-44.6-44.606zm0 78.333H57.377c-18.596 0-33.722-15.131-33.722-33.733 0-18.596 15.126-33.728 33.722-33.728H233.63c18.596 0 33.722 15.131 33.722 33.728 0 18.602-15.126 33.733-33.722 33.733zM233.63 201.789H57.377c-24.59 0-44.6 20.01-44.6 44.606s20.01 44.611 44.6 44.611H233.63c24.59 0 44.6-20.01 44.6-44.611 0-24.595-20.005-44.606-44.6-44.606zm0 78.334H57.377c-18.596 0-33.722-15.132-33.722-33.733 0-18.596 15.126-33.728 33.722-33.728H233.63c18.596 0 33.722 15.131 33.722 33.728 0 18.601-15.126 33.733-33.722 33.733z"></path>
        <path d="M73.922 19.809c-13.674 0-24.797 11.123-24.797 24.797s11.123 24.802 24.797 24.802 24.802-11.123 24.802-24.802c-.005-13.669-11.128-24.797-24.802-24.797zm0 38.721c-7.675 0-13.919-6.244-13.919-13.924s6.239-13.919 13.919-13.919 13.924 6.244 13.924 13.919S81.597 58.53 73.922 58.53zM73.922 120.698c-13.674 0-24.797 11.123-24.797 24.797 0 13.674 11.123 24.797 24.797 24.797s24.802-11.123 24.802-24.797c0-13.674-11.128-24.797-24.802-24.797zm0 38.721c-7.675 0-13.919-6.244-13.919-13.919s6.239-13.919 13.919-13.919 13.924 6.244 13.924 13.919-6.249 13.919-13.924 13.919zM73.922 221.587c-13.674 0-24.797 11.123-24.797 24.797 0 13.674 11.123 24.797 24.797 24.797s24.802-11.123 24.802-24.797c0-13.674-11.128-24.797-24.802-24.797zm0 38.716c-7.675 0-13.919-6.244-13.919-13.919 0-7.675 6.239-13.919 13.919-13.919s13.924 6.244 13.924 13.919-6.249 13.919-13.924 13.919z"></path>
      </g>
    </svg>
  );
};

export const SVG_OPTIONS_SMALL = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      x="0"
      y="0"
      width="20"
      height="20"
      enableBackground="new 0 0 291.006 291.006"
      version="1.1"
      viewBox="0 0 291.006 291.006"
      xmlSpace="preserve"
      fill="#6B7280"
    >
      <g fill="#010002">
        <path d="M57.377 0c-24.59 0-44.6 20.01-44.6 44.606s20.01 44.611 44.6 44.611H233.63c24.59 0 44.6-20.01 44.6-44.611C278.23 20.01 258.22 0 233.63 0H57.377zm209.975 44.6c0 18.596-15.126 33.733-33.722 33.733H57.377c-18.596 0-33.722-15.131-33.722-33.733 0-18.596 15.126-33.728 33.722-33.728H233.63c18.596.006 33.722 15.132 33.722 33.728zM233.63 100.895H57.377c-24.59 0-44.6 20.01-44.6 44.606s20.01 44.611 44.6 44.611H233.63c24.59 0 44.6-20.01 44.6-44.611 0-24.596-20.005-44.606-44.6-44.606zm0 78.333H57.377c-18.596 0-33.722-15.131-33.722-33.733 0-18.596 15.126-33.728 33.722-33.728H233.63c18.596 0 33.722 15.131 33.722 33.728 0 18.602-15.126 33.733-33.722 33.733zM233.63 201.789H57.377c-24.59 0-44.6 20.01-44.6 44.606s20.01 44.611 44.6 44.611H233.63c24.59 0 44.6-20.01 44.6-44.611 0-24.595-20.005-44.606-44.6-44.606zm0 78.334H57.377c-18.596 0-33.722-15.132-33.722-33.733 0-18.596 15.126-33.728 33.722-33.728H233.63c18.596 0 33.722 15.131 33.722 33.728 0 18.601-15.126 33.733-33.722 33.733z"></path>
        <path d="M73.922 19.809c-13.674 0-24.797 11.123-24.797 24.797s11.123 24.802 24.797 24.802 24.802-11.123 24.802-24.802c-.005-13.669-11.128-24.797-24.802-24.797zm0 38.721c-7.675 0-13.919-6.244-13.919-13.924s6.239-13.919 13.919-13.919 13.924 6.244 13.924 13.919S81.597 58.53 73.922 58.53zM73.922 120.698c-13.674 0-24.797 11.123-24.797 24.797 0 13.674 11.123 24.797 24.797 24.797s24.802-11.123 24.802-24.797c0-13.674-11.128-24.797-24.802-24.797zm0 38.721c-7.675 0-13.919-6.244-13.919-13.919s6.239-13.919 13.919-13.919 13.924 6.244 13.924 13.919-6.249 13.919-13.924 13.919zM73.922 221.587c-13.674 0-24.797 11.123-24.797 24.797 0 13.674 11.123 24.797 24.797 24.797s24.802-11.123 24.802-24.797c0-13.674-11.128-24.797-24.802-24.797zm0 38.716c-7.675 0-13.919-6.244-13.919-13.919 0-7.675 6.239-13.919 13.919-13.919s13.924 6.244 13.924 13.919-6.249 13.919-13.924 13.919z"></path>
      </g>
    </svg>
  );
};

export const SVG_LIVE_ORDER = () => {
  return (
    <span role="img" className="anticon anticon-dashboard ant-menu-item-icon">
      <svg
        xmlns="https://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 48 48"
      >
        <circle cx="24" cy="24" r="6" fill="#e60019"></circle>
        <path
          fill="#e60019"
          d="M17.09 16.789L14.321 13.9C11.663 16.448 10 20.027 10 24s1.663 7.552 4.321 10.1l2.769-2.889A9.966 9.966 0 0114 24c0-2.833 1.19-5.39 3.09-7.211zM33.679 13.9l-2.769 2.889A9.966 9.966 0 0134 24a9.966 9.966 0 01-3.09 7.211l2.769 2.889C36.337 31.552 38 27.973 38 24s-1.663-7.552-4.321-10.1z"
        ></path>
        <g fill="#e60019">
          <path d="M11.561 11.021l-2.779-2.9C4.605 12.125 2 17.757 2 24s2.605 11.875 6.782 15.879l2.779-2.9C8.142 33.701 6 29.1 6 24s2.142-9.701 5.561-12.979zM39.218 8.121l-2.779 2.9C39.858 14.299 42 18.9 42 24s-2.142 9.701-5.561 12.979l2.779 2.9C43.395 35.875 46 30.243 46 24s-2.605-11.875-6.782-15.879z"></path>
        </g>
      </svg>
    </span>
  );
};

export const SVG_INSTAGRAM = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <path
        fill="#304ffe"
        d="M41.67 13.48c-.4.26-.97.5-1.21.77-.09.09-.14.19-.12.29v1.03l-.3 1.01-.3 1-.33 1.1-.68 2.25-.66 2.22-.5 1.67c0 .26-.01.52-.03.77-.07.96-.27 1.88-.59 2.74-.19.53-.42 1.04-.7 1.52-.1.19-.22.38-.34.56-.4.63-.88 1.21-1.41 1.72-.41.41-.86.79-1.35 1.11h-.01c-.08.07-.17.13-.27.18-.31.21-.64.39-.98.55-.23.12-.46.22-.7.31-.05.03-.11.05-.16.07-.57.27-1.23.45-1.89.54-.04.01-.07.01-.11.02-.4.07-.79.13-1.19.16-.18.02-.37.03-.55.03l-.71-.04-3.42-.18c0-.01-.01 0-.01 0l-1.72-.09c-.13 0-.27 0-.4-.01-.54-.02-1.06-.08-1.58-.19h-.01c-.95-.18-1.86-.5-2.71-.93-.47-.24-.93-.51-1.36-.82-.18-.13-.35-.27-.52-.42-.48-.4-.91-.83-1.31-1.27-.06-.06-.11-.12-.16-.18-.06-.06-.12-.13-.17-.19-.38-.48-.7-.97-.96-1.49-.24-.46-.43-.95-.58-1.49-.06-.19-.11-.37-.15-.57a.076.076 0 01-.02-.05c-.1-.41-.19-.84-.24-1.27-.06-.33-.09-.66-.09-1-.02-.13-.02-.27-.02-.4l1.91-2.95 1.87-2.88.85-1.31.77-1.18.26-.41v-1.03c.02-.23.03-.47.02-.69-.01-.7-.15-1.38-.38-2.03-.22-.69-.53-1.34-.85-1.94-.38-.69-.78-1.31-1.11-1.87-.49-.82-.83-1.49-.74-1.96C14.47 6.09 15.23 6 16 6h16c4.18 0 7.78 2.6 9.27 6.26.16.39.3.8.4 1.22z"
      ></path>
      <path
        fill="#4928f4"
        d="M42 16v.27l-1.38.8-.88.51-.97.56-1.94 1.13-1.9 1.1-1.94 1.12-.77.45c0 .48-.12.92-.34 1.32-.31.58-.83 1.06-1.49 1.47-.67.41-1.49.74-2.41.98 0 0 0-.01-.01 0-3.56.92-8.42.5-10.78-1.26-.66-.49-1.12-1.09-1.32-1.78a2.92 2.92 0 01-.09-.73v-7.19c.01-.15-.09-.3-.27-.45-.54-.43-1.81-.84-3.23-1.25-1.11-.31-2.3-.62-3.3-.92-.79-.24-1.46-.48-1.86-.71.18-.35.39-.7.61-1.03 1.4-2.05 3.54-3.56 6.02-4.13C14.47 6.09 15.23 6 16 6h10.8a33.68 33.68 0 0114.47 6.26c.16.39.3.8.4 1.22.18.66.29 1.34.32 2.05.01.15.01.31.01.47z"
      ></path>
      <path
        fill="#6200ea"
        d="M42 16v4.41l-.22.68-.75 2.33-.78 2.4-.41 1.28-.38 1.19-.37 1.13-.36 1.12-.19.59-.25.78c0 .76-.02 1.43-.07 2-.01.06-.02.12-.02.18-.06.53-.14.98-.27 1.36-.01.06-.03.12-.05.17-.26.72-.65 1.18-1.23 1.48-.14.08-.3.14-.47.2-.53.18-1.2.27-2.02.32-.6.04-1.29.05-2.07.05h-.69l-1.19-.05-.21-.01-2.17-.09-2.2-.09-7.25-.3-1.88-.08h-.26c-.78-.01-1.45-.06-2.03-.14-.84-.13-1.49-.35-1.98-.68-.7-.45-1.11-1.11-1.35-2.03-.06-.22-.11-.45-.14-.7-.1-.58-.15-1.25-.18-2 0-.15 0-.3-.01-.46-.01-.01 0-.01 0-.01v-.58c-.01-.29-.01-.59-.01-.9l.05-1.61.03-1.15.04-1.34v-.19l.07-2.46.07-2.46.07-2.31.06-2.27.02-.6c0-.31-1.05-.49-2.22-.64-.93-.12-1.95-.23-2.56-.37.05-.23.1-.46.16-.68.18-.72.45-1.4.79-2.05.18-.35.39-.7.61-1.03 2.16-.95 4.41-1.69 6.76-2.17 2.06-.43 4.21-.66 6.43-.66 7.36 0 14.16 2.49 19.54 6.69.52.4 1.03.83 1.53 1.28.01.15.01.31.01.47z"
      ></path>
      <path
        fill="#673ab7"
        d="M42 18.37v4.54l-.55 1.06-1.05 2.05-.56 1.08-.51.99-.22.43c0 .31 0 .61-.02.9 0 .43-.02.84-.05 1.22-.04.45-.1.86-.16 1.24-.15.79-.36 1.47-.66 2.03-.04.07-.08.14-.12.2-.11.18-.24.35-.38.51-.18.22-.38.41-.61.57-.34.26-.74.47-1.2.63-.57.21-1.23.35-2.01.43-.51.05-1.07.08-1.68.08l-.42.02-2.08.12h-.01l-2.21.13-2.25.13-3.1.18-3.77.22-.55.03c-.51 0-.99-.03-1.45-.09-.05-.01-.09-.02-.14-.02-.68-.11-1.3-.29-1.86-.54-.68-.3-1.27-.7-1.77-1.18-.44-.43-.82-.92-1.13-1.47-.07-.13-.14-.25-.2-.39-.3-.59-.54-1.25-.72-1.97-.03-.12-.06-.25-.08-.38-.06-.23-.11-.47-.14-.72-.11-.64-.17-1.32-.2-2.03v-.01c-.01-.29-.02-.57-.02-.87l-.49-1.17-.07-.18-.06-.15-.75-1.79-.12-.29-.72-1.73-.8-1.93H7.1l-.81-1.95-.29-.71V16c0-.63.06-1.25.17-1.85.05-.23.1-.46.16-.68.85-.49 1.74-.94 2.65-1.34 2.08-.93 4.31-1.62 6.62-2.04 1.72-.31 3.51-.48 5.32-.48 7.31 0 13.94 2.65 19.12 6.97.2.16.39.32.58.49.47.41.93.84 1.38 1.3z"
      ></path>
      <path
        fill="#8e24aa"
        d="M42 21.35v5.14l-.57 1.19-1.08 2.25-.01.03c0 .43-.02.82-.05 1.17-.1 1.15-.38 1.88-.84 2.33-.33.34-.74.53-1.25.63-.03.01-.07.01-.1.02-.16.03-.33.05-.51.05-.62.06-1.35.02-2.19-.04-.09 0-.19-.01-.29-.02-.61-.04-1.26-.08-1.98-.11-.39-.01-.8-.02-1.22-.02h-.02l-1.01.08h-.01l-2.27.16-2.59.2-.38.03-3.03.22-1.57.12-1.55.11c-.27 0-.53 0-.79-.01 0 0-.01-.01-.01 0-1.13-.02-2.14-.09-3.04-.26-.83-.14-1.56-.36-2.18-.69-.64-.31-1.17-.75-1.6-1.31-.41-.55-.71-1.24-.9-2.07v-.01c-.14-.67-.22-1.45-.22-2.33l-.15-.27-.89-1.59-.13-.22-.07-.14-.93-1.65-.46-.83-.58-1.03-1-1.79-.53-.94v-3.68c.88-.58 1.79-1.09 2.73-1.55 1.14-.58 2.32-1.07 3.55-1.47 1.34-.44 2.74-.79 4.17-1.02 1.45-.24 2.94-.36 4.47-.36 6.8 0 13.04 2.43 17.85 6.47.22.17.43.36.64.54.84.75 1.64 1.56 2.37 2.41.08.09.16.17.22.26z"
      ></path>
      <path
        fill="#c2185b"
        d="M42 24.71v7.23c-.24-.14-.57-.31-.98-.49-.22-.11-.47-.22-.73-.32-.38-.17-.79-.33-1.25-.49-.1-.04-.2-.07-.31-.1-.18-.07-.37-.13-.56-.19-.59-.18-1.24-.35-1.92-.5-.26-.05-.53-.1-.8-.14-.87-.15-1.8-.24-2.77-.25-.08-.01-.17-.01-.25-.01l-2.57.02-3.5.02h-.01l-7.49.06c-2.38 0-3.84.57-4.72.8 0 0-.01 0-.01.01-.93.24-1.22.09-1.3-1.54-.02-.45-.03-1.03-.03-1.74l-.56-.43-.98-.74-.6-.46-.12-.09-1.66-1.26-.25-.19-.52-.4-.96-.72L6 21.91v-3.4c.1-.08.19-.15.29-.21 1.45-1 3-1.85 4.64-2.54 1.46-.62 3-1.11 4.58-1.46.43-.09.87-.18 1.32-.24 1.33-.23 2.7-.34 4.09-.34 6.01 0 11.53 2.09 15.91 5.55.66.52 1.3 1.07 1.9 1.66.82.78 1.59 1.61 2.3 2.49.14.18.28.36.42.55.19.24.37.49.55.74z"
      ></path>
      <path
        fill="#d81b60"
        d="M42 28.72V32c0 .65-.06 1.29-.18 1.91-.18.92-.49 1.8-.91 2.62-.22.05-.47.05-.75.01-.63-.11-1.37-.44-2.17-.87a.37.37 0 01-.11-.05c-.25-.13-.51-.27-.77-.43-.53-.29-1.09-.61-1.65-.91-.12-.06-.24-.12-.35-.18-.64-.33-1.3-.63-1.96-.86h-.01c-.14-.05-.29-.1-.44-.14-.57-.16-1.15-.26-1.71-.26l-1.1-.32-4.87-1.41h-.01l-2.99-.87h-.01l-1.3-.38c-3.76 0-6.07 1.6-7.19.99-.44-.23-.7-.81-.79-1.95-.03-.32-.04-.68-.04-1.1l-1.17-.57-.05-.02h-.01l-.84-.42-.92-.44-.07-.03-.17-.09-1.96-.95-1.5-.73v-3.43c.17-.15.35-.29.53-.43.19-.15.38-.29.57-.44h.01c1.18-.85 2.43-1.6 3.76-2.22 1.55-.74 3.2-1.31 4.91-1.68.25-.06.51-.12.77-.16 1.42-.27 2.88-.41 4.37-.41 5.27 0 10.11 1.71 14.01 4.59 1.13.84 2.18 1.77 3.14 2.78.79.83 1.52 1.73 2.18 2.67.05.07.1.14.15.2.37.54.71 1.09 1.03 1.66.21.34.39.69.57 1.04z"
      ></path>
      <path
        fill="#f50057"
        d="M41.82 33.91a9.929 9.929 0 01-1.54 3.68c-.14.21-.29.41-.44.6-.36-.14-.89-.34-1.54-.56v-.01c-.49-.17-1.05-.35-1.65-.52a18.217 18.217 0 00-2.69-.61c-.6-.1-1.19-.16-1.74-.16l-.46-.13h-.01l-2.42-.7-1.49-.43-1.66-.48h-.01l-.54-.15-6.53-1.88-1.88-.54-1.4-.33-2.28-.54-.28-.07h-.01l-2.29-.53v-.01l-.41-.09-.21-.05-1.67-.39-.19-.05-1.42-1.17L6 27.9v-4.08c.37-.36.75-.7 1.15-1.03.12-.11.25-.21.38-.31.12-.1.25-.2.38-.3a20.2 20.2 0 012.89-1.84c1.3-.7 2.68-1.26 4.13-1.66.28-.09.56-.17.85-.23 1.64-.41 3.36-.62 5.14-.62a21.594 21.594 0 0116.62 7.76c.66.79 1.26 1.62 1.79 2.5.05.07.09.13.13.2.32.53.62 1.08.89 1.64.25.5.47 1 .67 1.52.32.8.58 1.62.8 2.46z"
      ></path>
      <path
        fill="#ff1744"
        d="M40.28 37.59a9.802 9.802 0 01-1.9 2.09c-.47.39-.97.74-1.5 1.04-.2-.05-.4-.11-.61-.19-.66-.23-1.35-.61-1.99-1.01-.96-.61-1.79-1.27-2.16-1.57l-.21-.18-1.7-.15-.21-.02-2.2-.19-2.28-.2-3.37-.3-5.34-.47-.02-.01-1.88-.91-1.9-.92-1.53-.74-.33-.16-.41-.2-1.42-.69-1.89-.91-.59-.29-.84-.26v-4.47c.47-.56.97-1.09 1.5-1.6.34-.32.7-.64 1.07-.94.06-.05.12-.1.18-.14.04-.05.09-.08.13-.1.59-.48 1.21-.91 1.85-1.3.74-.47 1.52-.89 2.33-1.24.87-.39 1.78-.72 2.72-.97 1.63-.46 3.36-.7 5.14-.7 4.08 0 7.85 1.24 10.96 3.37 1.99 1.36 3.71 3.08 5.07 5.07.45.64.85 1.32 1.22 2.02.13.26.26.52.37.78.12.25.23.5.34.75.21.52.4 1.04.57 1.58a18.624 18.624 0 01.83 4.13z"
      ></path>
      <path
        fill="#ff5722"
        d="M38.39 39.42c0 .08 0 .17-.01.26-.47.39-.97.74-1.5 1.04-.22.12-.44.24-.67.34-.23.11-.46.21-.7.3-.34-.18-.8-.4-1.29-.61-.69-.31-1.44-.59-2.02-.68-.14-.03-.27-.04-.39-.04l-1.64-.21h-.02l-2.04-.27-2.06-.27-.96-.12-7.56-.98c-.49 0-1.01-.03-1.55-.1-.66-.06-1.35-.16-2.04-.3-.68-.12-1.37-.28-2.03-.45-.69-.16-1.37-.35-2-.53a74.552 74.552 0 01-3.16-1.02c-.18-.43-.33-.88-.44-1.34A9.38 9.38 0 016 32v-1.67c.32-.53.67-1.05 1.06-1.54.71-.94 1.52-1.8 2.4-2.56.03-.04.07-.07.1-.09l.01-.01c.31-.28.63-.53.97-.77.04-.04.08-.07.12-.1.16-.12.33-.24.51-.35a17.24 17.24 0 014.7-2.24c1.6-.48 3.29-.73 5.05-.73 3.49 0 6.75 1.03 9.47 2.79 2.01 1.29 3.74 2.99 5.06 4.98.16.23.31.46.46.7.69 1.17 1.26 2.43 1.68 3.75.05.15.09.3.13.46.08.27.15.55.21.83.02.07.04.14.06.22.14.63.24 1.29.31 1.95v.01c.06.59.09 1.19.09 1.79z"
      ></path>
      <path
        fill="#ff6f00"
        d="M36.33 39.42c0 .35-.02.73-.06 1.11l-.06.53a9.503 9.503 0 01-2.08.71c-.32.07-.65.13-.98.16h-.01c-.31-.19-.67-.42-1.04-.68-.67-.47-1.37-1-1.93-1.43l-.02-.02c-.59-.45-1.01-.79-1.01-.79l-1.06.04-2.04.07-.95.04-3.82.14-3.23.12c-.21.01-.46.01-.77 0h-.01c-.42-.01-.92-.04-1.47-.09-.64-.05-1.34-.11-2.05-.18-.69-.08-1.39-.16-2.06-.24-.74-.08-1.44-.17-2.04-.25-.47-.06-.88-.11-1.21-.15-.28-.32-.53-.65-.77-1.01a9.12 9.12 0 01-.91-1.72c-.18-.43-.33-.88-.44-1.34.29-.89.67-1.73 1.12-2.54.36-.66.78-1.29 1.24-1.89.45-.59.94-1.14 1.47-1.64v-.01c.15-.15.3-.29.45-.42.28-.26.57-.5.87-.73h.01c.01-.02.02-.02.03-.03.24-.19.49-.36.74-.53a15.15 15.15 0 014.95-2.2c1.19-.29 2.44-.45 3.73-.45 2.54 0 4.94.61 7.05 1.71h.01c1.81.93 3.41 2.21 4.7 3.75.71.82 1.32 1.72 1.82 2.67.35.64.65 1.31.9 1.99.02.06.04.11.06.16.17.5.32 1.02.45 1.54.09.37.16.75.22 1.13.02.12.04.23.05.35.1.69.15 1.4.15 2.12z"
      ></path>
      <path
        fill="#ff9800"
        d="M34.28 39.42v.1c0 .34-.03.77-.06 1.23l-.09 1.02c-.32.07-.65.13-.98.16h-.01c-.38.05-.75.07-1.14.07h-1.75l-.38-.11-1.97-.6-2-.6-4.63-1.39-2-.6s-.83.33-2 .72h-.01c-.45.15-.94.31-1.46.47-.65.19-1.34.38-2.02.53-.7.16-1.39.28-2.01.33-.19.02-.38.03-.55.03a10.282 10.282 0 01-3.56-3.28c.07-.45.15-.89.27-1.32.3-1.19.77-2.33 1.39-3.37.34-.59.72-1.16 1.16-1.69.01-.03.04-.06.07-.08-.01-.01 0-.01 0-.01.13-.17.27-.33.41-.48v-.01c.41-.44.83-.86 1.29-1.25.16-.13.31-.26.48-.39.03-.03.06-.05.1-.08 2.25-1.72 5.06-2.76 8.09-2.76 3.44 0 6.57 1.29 8.94 3.41a13.4 13.4 0 012.84 3.63c.06.1.12.21.17.32.09.18.18.37.26.57.33.72.59 1.48.77 2.26l.06.24a13.382 13.382 0 01.32 2.93z"
      ></path>
      <path
        fill="#ffc107"
        d="M32.22 39.42c0 .2-.01.42-.02.65-.02.37-.05.77-.1 1.18-.02.25-.06.5-.1.75h-5.48l-1.06-.17-4.14-.66-.59-.09-1.35-.22c-.59 0-1.87.26-3.22.51-.71.13-1.43.27-2.08.36l-.23.03h-.01c-.7-.15-1.38-.38-2.02-.68-.2-.09-.4-.19-.6-.3-.56-.31-1.1-.68-1.59-1.09-.01-.12-.02-.22-.02-.27 0-.26.01-.51.03-.76.04-.64.13-1.26.27-1.86.22-.91.54-1.79.97-2.6.08-.17.17-.34.27-.5.04-.08.09-.15.13-.23.18-.29.38-.57.58-.85.42-.55.89-1.07 1.39-1.54h.01c.04-.04.08-.08.12-.11.05-.04.09-.09.14-.12.2-.18.4-.34.61-.49 0-.01.01-.01.01-.01a11.28 11.28 0 016.78-2.24c1.98 0 3.82.5 5.43 1.38h.01c1.38.76 2.58 1.79 3.53 3.03.37.48.7.99.98 1.53h.01l.15.3c.3.59.54 1.21.72 1.85h.01c.01.05.03.1.04.15.12.43.22.87.29 1.32l.03.28c.07.48.1.97.1 1.47z"
      ></path>
      <path
        fill="#ffd54f"
        d="M30.17 39.31c0 .16 0 .33-.02.49v.02c-.02.72-.12 1.43-.28 2.07 0 .04-.01.07-.03.11h-4.67l-3.85-.83-.51-.11-.08.02-4.27.88-.19.04H16c-.64 0-1.27-.06-1.88-.18l-.27-.06h-.01c-.7-.15-1.38-.38-2.02-.68-.02-.11-.04-.22-.05-.33-.07-.43-.1-.88-.1-1.33 0-.17 0-.34.01-.51.03-.54.11-1.07.23-1.58.08-.38.19-.75.32-1.1.11-.31.24-.61.38-.9.12-.25.26-.49.4-.73.14-.23.29-.45.45-.67a9.029 9.029 0 012.36-2.24 9.245 9.245 0 015.1-1.52c.37 0 .73.02 1.08.07h.02c1.07.12 2.07.42 2.99.87h.01c1.45.71 2.68 1.78 3.58 3.1.15.22.3.46.43.7.11.19.21.39.3.59.14.31.27.64.38.97h.01c.11.37.21.74.28 1.13v.01c.11.55.17 1.12.17 1.7z"
      ></path>
      <path
        fill="#ffe082"
        d="M28.11 39.52v.03c0 .59-.07 1.17-.21 1.74-.05.24-.12.48-.21.71h-4.48l-2.29-.63-2.29.63H16c-.64 0-1.27-.06-1.88-.18-.02-.03-.03-.06-.04-.09-.14-.43-.25-.86-.3-1.31-.04-.29-.06-.59-.06-.9 0-.12 0-.25.02-.37.01-.47.08-.93.2-1.37.06-.3.15-.59.27-.87.04-.14.1-.27.17-.4.15-.34.33-.67.53-.99.22-.32.46-.62.73-.9.32-.36.68-.69 1.09-.96.7-.51 1.5-.89 2.37-1.1.58-.16 1.19-.24 1.82-.24 2 0 3.79.8 5.09 2.09.05.05.11.11.16.18h.01c.14.15.27.3.4.47.37.47.68.98.92 1.54.12.26.22.53.3.81l.03.11c.14.49.23 1 .25 1.53.02.15.03.31.03.47z"
      ></path>
      <path
        fill="#ffecb3"
        d="M26.06 39.52c0 .41-.05.8-.16 1.17-.1.4-.25.78-.44 1.14-.03.06-.1.17-.1.17h-8.88a.076.076 0 01-.02-.04c-.12-.19-.22-.38-.3-.59-.2-.46-.32-.96-.36-1.48-.02-.12-.02-.25-.02-.37 0-.06 0-.13.01-.19.01-.44.07-.86.19-1.25.1-.36.23-.69.4-1.01 0 0 .01-.01.01-.02.12-.21.25-.42.4-.62.49-.66 1.14-1.2 1.89-1.55h.01c.24-.12.49-.22.75-.29h.01c.46-.14.96-.21 1.47-.21.59 0 1.16.09 1.68.28.19.05.37.13.55.22h.01c.86.41 1.59 1.05 2.09 1.85.1.15.19.31.27.48.04.07.08.15.11.22.23.52.37 1.09.41 1.69.01.05.01.1.01.16.01.08.01.16.01.24z"
      ></path>
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M30 11H18c-3.9 0-7 3.1-7 7v12c0 3.9 3.1 7 7 7h12c3.9 0 7-3.1 7-7V18c0-3.9-3.1-7-7-7z"
      ></path>
      <circle cx="31" cy="16" r="1" fill="#fff"></circle>
      <g>
        <circle
          cx="24"
          cy="24"
          r="6"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
        ></circle>
      </g>
    </svg>
  );
};

export const SVG_FACEBOOK = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <linearGradient
        id="Ld6sqrtcxMyckEl6xeDdMa"
        x1="9.993"
        x2="40.615"
        y1="9.993"
        y2="40.615"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#2aa4f4"></stop>
        <stop offset="1" stopColor="#007ad9"></stop>
      </linearGradient>
      <path
        fill="url(#Ld6sqrtcxMyckEl6xeDdMa)"
        d="M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4z"
      ></path>
      <path
        fill="#fff"
        d="M26.707 29.301h5.176l.813-5.258h-5.989v-2.874c0-2.184.714-4.121 2.757-4.121h3.283V12.46c-.577-.078-1.797-.248-4.102-.248-4.814 0-7.636 2.542-7.636 8.334v3.498H16.06v5.258h4.948v14.452c.98.146 1.973.246 2.992.246.921 0 1.82-.084 2.707-.204V29.301z"
      ></path>
    </svg>
  );
};

export const SVG_WHATSAPP = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <path
        fill="#fff"
        d="M4.868 43.303l2.694-9.835a18.941 18.941 0 01-2.535-9.489C5.032 13.514 13.548 5 24.014 5a18.867 18.867 0 0113.43 5.566A18.866 18.866 0 0143 23.994c-.004 10.465-8.522 18.98-18.986 18.98-.001 0 0 0 0 0h-.008a18.965 18.965 0 01-9.073-2.311l-10.065 2.64z"
      ></path>
      <path
        fill="#fff"
        d="M4.868 43.803a.499.499 0 01-.482-.631l2.639-9.636a19.48 19.48 0 01-2.497-9.556C4.532 13.238 13.273 4.5 24.014 4.5a19.367 19.367 0 0113.784 5.713A19.362 19.362 0 0143.5 23.994c-.004 10.741-8.746 19.48-19.486 19.48a19.535 19.535 0 01-9.144-2.277l-9.875 2.589a.457.457 0 01-.127.017z"
      ></path>
      <path
        fill="#cfd8dc"
        d="M24.014 5a18.867 18.867 0 0113.43 5.566A18.866 18.866 0 0143 23.994c-.004 10.465-8.522 18.98-18.986 18.98h-.008a18.965 18.965 0 01-9.073-2.311l-10.065 2.64 2.694-9.835a18.941 18.941 0 01-2.535-9.489C5.032 13.514 13.548 5 24.014 5m0-1C12.998 4 4.032 12.962 4.027 23.979a20.01 20.01 0 002.461 9.622L3.903 43.04a.998.998 0 001.219 1.231l9.687-2.54a20.026 20.026 0 009.197 2.244c11.024 0 19.99-8.963 19.995-19.98A19.856 19.856 0 0038.153 9.86 19.869 19.869 0 0024.014 4z"
      ></path>
      <path
        fill="#40c351"
        d="M35.176 12.832a15.673 15.673 0 00-11.157-4.626c-8.704 0-15.783 7.076-15.787 15.774a15.738 15.738 0 002.413 8.396l.376.597-1.595 5.821 5.973-1.566.577.342a15.75 15.75 0 008.032 2.199h.006c8.698 0 15.777-7.077 15.78-15.776a15.68 15.68 0 00-4.618-11.161z"
      ></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M19.268 16.045c-.355-.79-.729-.806-1.068-.82-.277-.012-.593-.011-.909-.011-.316 0-.83.119-1.265.594-.435.475-1.661 1.622-1.661 3.956 0 2.334 1.7 4.59 1.937 4.906.237.316 3.282 5.259 8.104 7.161 4.007 1.58 4.823 1.266 5.693 1.187.87-.079 2.807-1.147 3.202-2.255.395-1.108.395-2.057.277-2.255-.119-.198-.435-.316-.909-.554s-2.807-1.385-3.242-1.543c-.435-.158-.751-.237-1.068.238-.316.474-1.225 1.543-1.502 1.859-.277.317-.554.357-1.028.119s-2.002-.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285-.277-.474-.03-.731.208-.968.213-.213.474-.554.712-.831.237-.277.316-.475.474-.791.158-.317.079-.594-.04-.831-.117-.238-1.039-2.584-1.461-3.522z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
export const SVG_MESSENGER = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 800 800"
    >
      <radialGradient
        id="Gradient"
        cx="101.925"
        cy="809.008"
        r="1.09"
        gradientTransform="matrix(800 0 0 -799.9985 -81386 648000.75)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#09F"></stop>
        <stop offset="0.61" stopColor="#A033FF"></stop>
        <stop offset="0.935" stopColor="#FF5280"></stop>
        <stop offset="1" stopColor="#FF7061"></stop>
      </radialGradient>
      <path
        fill="url(#Gradient)"
        d="M400 0C174.7 0 0 165.1 0 388c0 116.6 47.8 217.4 125.6 287 6.5 5.8 10.5 14 10.7 22.8l2.2 71.2c.7 22.7 24.1 37.5 44.9 28.3l79.4-35c6.7-3 14.3-3.5 21.4-1.6 36.5 10 75.3 15.4 115.8 15.4 225.3 0 400-165.1 400-388S625.3 0 400 0z"
      ></path>
      <path
        fill="#FFF"
        d="M159.8 501.5l117.5-186.4c18.7-29.7 58.7-37 86.8-16l93.5 70.1c8.6 6.4 20.4 6.4 28.9-.1l126.2-95.8c16.8-12.8 38.8 7.4 27.6 25.3L522.7 484.9c-18.7 29.7-58.7 37-86.8 16l-93.5-70.1c-8.6-6.4-20.4-6.4-28.9.1l-126.2 95.8c-16.8 12.8-38.8-7.3-27.5-25.2z"
      ></path>
    </svg>
  );
};

export const SVG_DRAGDROP = () => {
  return (
    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 640 512">
      <path
        fill="gray"
        d="M626.29 224H269.71c-7.57 0-13.71 7.16-13.71 16v32c0 8.84 6.14 16 13.71 16h356.58c7.57 0 13.71-7.16 13.71-16v-32c0-8.84-6.14-16-13.71-16zm0 160H269.71c-7.57 0-13.71 7.16-13.71 16v32c0 8.84 6.14 16 13.71 16h356.58c7.57 0 13.71-7.16 13.71-16v-32c0-8.84-6.14-16-13.71-16zm0-320H269.71C262.14 64 256 71.16 256 80v32c0 8.84 6.14 16 13.71 16h356.58c7.57 0 13.71-7.16 13.71-16V80c0-8.84-6.14-16-13.71-16zM176 144c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 00-22.62 0l-80 80C-4.64 126 .36 144 16 144h48v224H16c-14.29 0-21.31 17.31-11.29 27.31l80 80a16 16 0 0022.62 0l80-80C196.64 386 191.64 368 176 368h-48V144z"
      ></path>
    </svg>
  );
};

export const SVG_FOOD_AND_BEVARAGES = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      xmlnsXlink="https://www.w3.org/1999/xlink"
      width="48"
      height="48"
      viewBox="0 0 700 700"
    >
      <path d="M139.8 102.47c-4.957-.172-9.621 2.777-11.551 7.352-1.93 4.574-.758 9.843 2.8 13.3l39.2 39.552v26.25h-41.301c-11.414 0-21.098 9.062-22.051 20.477l-.352 4.55.004-.004a3.361 3.361 0 001.223 2.801c-3.668 5.102-5.774 11.285-5.774 18.023v53.898a3.96 3.96 0 000 .528v68.074c-.023.23-.023.464 0 .699v53.727c0 6.656 2.192 12.816 5.774 17.852v-.004a3.358 3.358 0 00-1.223 2.977l.352 4.55c.953 11.414 10.633 20.477 22.05 20.477h107.1c11.415 0 21.099-9.062 22.052-20.477l.523-4.55h-.004a3.358 3.358 0 00-1.222-2.977c3.546-5.02 5.601-11.234 5.601-17.852v-53.898h-.004a2.972 2.972 0 000-.527v-68.074.004a2.972 2.972 0 000-.528v-53.898c0-6.605-2.066-12.629-5.601-17.676h.004a3.362 3.362 0 001.222-3.152l-.523-4.55c-.953-11.415-10.633-20.478-22.051-20.478h-41.824v-31.324c.008-3.191-1.254-6.309-3.5-8.574l-42.7-42.875c-.038-.04-.136.039-.175 0-2.16-2.172-4.98-3.586-8.05-3.676zm214.9 3.324c-.117.055-.234.11-.348.176l-40.602 12.602a3.356 3.356 0 00-2.273 4.023l20.125 80.5h-2.8l-12.075-58.102v.004c-.172-.925-.726-1.738-1.523-2.238s-1.77-.64-2.676-.387l-35 9.45a3.357 3.357 0 00-2.453 4.023l10.852 47.426a3.365 3.365 0 00-2.274 1.406c-.527.762-.718 1.711-.527 2.617l60.898 243.25h.004a3.358 3.358 0 003.324 2.625h178.33-.004a3.366 3.366 0 003.328-2.625l60.727-243.25h-.004c.258-.988.051-2.039-.562-2.855s-1.566-1.313-2.586-1.344h-6.648l17.852-48.125h-.004a3.36 3.36 0 00-2.625-4.55l-38.852-6.302 5.074-21 .004.004a3.362 3.362 0 00-2.277-3.851l-39.551-12.95h.003a3.44 3.44 0 00-.527-.35h-.351.003a3.446 3.446 0 00-1.05-.177 3.485 3.485 0 00-.7 0 3.37 3.37 0 00-2.453 2.454h-.175v.351l-13.648 55.125V137.47a3.36 3.36 0 00-3.325-3.324h-37.273v-25.023a3.363 3.363 0 00-3.324-3.328h-40.602a3.485 3.485 0 00-.7 0 3.363 3.363 0 00-2.624 3.328v25.023h-37.102a3.485 3.485 0 00-.7 0 3.358 3.358 0 00-2.624 3.324v24.852L358.734 109.3v-.004c.004-.113.004-.23 0-.347v-.352a4.821 4.821 0 00-.176-.348 3.364 3.364 0 00-3.852-2.453zm-215.07 3.324c1.305.04 2.582.625 3.5 1.575v.004h.176l42.699 43.05c.945.958 1.402 2.317 1.398 3.676l.004-.004a1.32 1.32 0 000 .176v31.324h-10.5v-27.824a3.353 3.353 0 00-.875-2.273l-40.25-40.426v-.176c-1.422-1.383-2-3.934-1.227-5.773.778-1.84 3.11-3.395 5.075-3.325zm279.83 3.325h33.949v24.504a5.158 5.158 0 000 .347v138.07c-5.348.465-10.957.7-16.977.7-3.023 0-5.894-.055-8.75-.172-2.812-.157-5.523-.45-8.227-.7v-137.73h.004a3.96 3.96 0 000-.527zm-66.5.875l19.426 75.426v.004a2.64 2.64 0 000 .351l20.648 80.5c-24.355-8.234-40.305-24.758-51.273-54.25 0-.004-.16-.125-.176-.172v-.172c-.015-.054-.14 0-.176 0-.02-.054.02-.125 0-.172l-22.574-90.648 34.125-10.852zm167.12.175l34.125 11.2-4.898 20.476c-.157.274-.274.57-.352.875l-10.676 45.676-3.148 12.773-.176.352v.176a3.565 3.565 0 00-.172.172 1.32 1.32 0 000 .175 1.867 1.867 0 00-.176.176c-1.344 4.371-2.851 8.54-4.375 12.426-.734 1.887-1.496 3.82-2.273 5.602-.39.883-.82 1.77-1.227 2.625-.812 1.742-1.59 3.437-2.449 5.074-10.207 19.164-23.934 30.867-42.699 37.625l9.273-37.102 9.625-37.273v-.004c.082-.227.141-.46.176-.7v-1.925l19.426-78.398zm-141.05 27.301h33.773v133.53c-4.219-.574-8.281-1.18-12.074-2.101l-21.699-84.875zm81.027 0h33.949v49.7l-11.551 46.726-9.102 34.648c-4.199 1.106-8.668 1.953-13.3 2.625v-133.7zm-149.27 8.926l11.023 53.375h-28.875l-10.676-45.676 28.523-7.699zm243.95 1.051l35.352 5.602-17.324 46.727h-30.449l12.426-52.324zm-425.77 44.977h107.1c6.23 0 10.914 4.512 13.301 10.148-2.793-1.23-5.687-1.926-8.926-1.926h-5.074a31.045 31.045 0 00-3.148-.176h-99.398c-1.063 0-2.114.07-3.149.176H124.6c-3.238 0-6.133.695-8.926 1.926 2.387-5.637 7.07-10.148 13.301-10.148zm161.88 14.176h42.176c.48 1.484.898 2.937 1.398 4.375l.7 2.45.004-.005c.042.184.101.36.175.528-.027-.075-.09-.09 0 .171v.004a1.262 1.262 0 000 .172c5.414 14.625 12.207 26.586 20.648 36.051 1.036 1.192 2.063 2.387 3.149 3.5.379.38.84.68 1.226 1.051 2.72 2.668 5.504 5.156 8.575 7.352 17.066 12.195 39.148 17.324 67.547 17.324 3.496 0 6.984 0 10.324-.172 3.492-.172 6.863-.52 10.148-.875l.003-.004c.059.004.118.004.176 0h.352c6.949-.777 13.359-2.172 19.426-3.852l-.004.004c.238-.035.473-.094.7-.176 1.937-.546 3.921-1.101 5.772-1.75 2.356-.832 4.61-1.625 6.825-2.625 4.914-2.195 9.558-4.824 13.824-7.875 4.566-3.265 8.597-7.062 12.426-11.375 1.394-1.546 2.718-3.043 4.023-4.726 2.285-2.985 4.453-6.219 6.477-9.625.812-1.344 1.68-2.785 2.449-4.2.242-.452.46-.94.7-1.398 1.108-2.097 2.124-4.234 3.147-6.476.813-1.797 1.688-3.711 2.45-5.602.39-.96.843-1.988 1.226-2.977.11-.285.242-.59.352-.875 1.015-2.687 1.875-5.53 2.8-8.398h42.177l-28.523 114.27v.004a3.485 3.485 0 00-.7 0h-232.4a2.972 2.972 0 00-.527 0 3.29 3.29 0 00-.523.348l-28.7-114.62zm-158.03.7h99.398a24.055 24.055 0 0124.148 24.147v51.102h-15.75V238.8c0-11.188-8.973-20.3-20.125-20.3h.008a2.64 2.64 0 00-.352 0 3.423 3.423 0 00-2.39 1.105 3.42 3.42 0 002.742 5.718c7.527 0 13.477 5.875 13.477 13.477v47.074h-125.3v-51.102a24.055 24.055 0 0124.148-24.148zm-24.148 81.897h125.3v61.426h-125.3zm131.95 0h15.75v61.426h-15.75zm-33.426 9.102c-8.79.054-17.324.172-17.324.172h.004a3.411 3.411 0 100 6.824s8.559-.129 17.324-.172h16.625c1.11 0 2.195.074 1.75 0a3.368 3.368 0 002.902-.2 3.356 3.356 0 001.66-2.386 3.357 3.357 0 00-.82-2.789 3.376 3.376 0 00-2.691-1.102c-1.008-.168-1.446-.152-2.625-.171-1.18 0-2.614-.168-4.375-.172h-12.426zm-65.801 18.199h.004a3.417 3.417 0 10.351 6.824h84.348a3.412 3.412 0 000-6.824h-84.348a2.64 2.64 0 00-.351 0zm179.73 11.023h230.83l-2.625 10.5H323.755l-2.625-10.5zm-131.77 7h.004a3.422 3.422 0 10.527 6.824s8.535-.055 17.324 0h16.801c1.18 0 1.617 0 2.625-.172a3.367 3.367 0 002.203-1.344 3.361 3.361 0 00-.742-4.71 3.385 3.385 0 00-2.512-.598c.446-.074-.64.152-1.75.172h-16.625c-8.765-.055-17.324-.172-17.324-.172a3.96 3.96 0 00-.527 0zm135.97 10.148h222.43l-2.625 10.5h-216.47l.004.004a2.99 2.99 0 00-.7 0l-2.624-10.5zm-216.65 12.602h125.3v47.074c0 7.601-5.95 13.477-13.477 13.477h.008a3.413 3.413 0 100 6.824c11.152 0 20.125-9.113 20.125-20.3v-47.075h15.75v51.102a24.055 24.055 0 01-24.148 24.148h-99.398a24.055 24.055 0 01-24.148-24.148v-51.102zm221.03 4.55h213.67l-20.301 81.376h-173.07L329.7 365.146zm-214.03 75.427c2.793 1.23 5.688 1.925 8.926 1.925h115.85c3.238 0 6.133-.695 8.926-1.925-2.387 5.636-7.07 10.148-13.301 10.148h-107.1c-6.23 0-10.914-4.512-13.301-10.148z"></path>
      <use x="70" y="644" xlinkHref="#w"></use>
      <use x="90.551" y="644" xlinkHref="#e"></use>
      <use x="104.359" y="644" xlinkHref="#a"></use>
      <use x="123.348" y="644" xlinkHref="#g"></use>
      <use x="142.242" y="644" xlinkHref="#d"></use>
      <use x="155.629" y="644" xlinkHref="#a"></use>
      <use x="174.617" y="644" xlinkHref="#f"></use>
      <use x="204.41" y="644" xlinkHref="#l"></use>
      <use x="224.453" y="644" xlinkHref="#k"></use>
      <use x="252.453" y="644" xlinkHref="#j"></use>
      <use x="280.313" y="644" xlinkHref="#g"></use>
      <use x="299.211" y="644" xlinkHref="#c"></use>
      <use x="319.141" y="644" xlinkHref="#i"></use>
      <use x="335.809" y="644" xlinkHref="#h"></use>
      <use x="345.406" y="644" xlinkHref="#b"></use>
      <use x="364.641" y="644" xlinkHref="#c"></use>
      <use x="384.578" y="644" xlinkHref="#v"></use>
      <use x="412.578" y="644" xlinkHref="#f"></use>
      <use x="432.617" y="644" xlinkHref="#a"></use>
      <use x="451.609" y="644" xlinkHref="#i"></use>
      <use x="468.273" y="644" xlinkHref="#h"></use>
      <use x="477.875" y="644" xlinkHref="#u"></use>
      <use x="497.914" y="644" xlinkHref="#c"></use>
      <use x="70" y="672" xlinkHref="#t"></use>
      <use x="82.184" y="672" xlinkHref="#e"></use>
      <use x="95.992" y="672" xlinkHref="#b"></use>
      <use x="115.227" y="672" xlinkHref="#s"></use>
      <use x="154.152" y="672" xlinkHref="#d"></use>
      <use x="167.535" y="672" xlinkHref="#r"></use>
      <use x="187.469" y="672" xlinkHref="#a"></use>
      <use x="216.207" y="672" xlinkHref="#q"></use>
      <use x="239.641" y="672" xlinkHref="#b"></use>
      <use x="258.879" y="672" xlinkHref="#p"></use>
      <use x="278.813" y="672" xlinkHref="#c"></use>
      <use x="308.492" y="672" xlinkHref="#o"></use>
      <use x="329.016" y="672" xlinkHref="#e"></use>
      <use x="342.82" y="672" xlinkHref="#b"></use>
      <use x="362.059" y="672" xlinkHref="#n"></use>
      <use x="371.656" y="672" xlinkHref="#a"></use>
      <use x="390.648" y="672" xlinkHref="#m"></use>
      <use x="407.242" y="672" xlinkHref="#d"></use>
    </svg>
  );
};

export const SVG_RETAIL = () => {
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 504 504"
      version="1.1"
      viewBox="0 0 504 504"
      xmlSpace="preserve"
    >
      <path
        fill="#B8BAC0"
        d="M485.617 114.305A7.99 7.99 0 00480 112h-.109l-374.5 4.941a8 8 0 00-7.508 10.441l62.5 195.059A8 8 0 00168 328h280c22.055 0 40-17.945 40-40V120a8 8 0 00-2.383-5.695zM208 288c0 4.418-3.578 8-8 8s-8-3.582-8-8V168c0-4.418 3.578-8 8-8s8 3.582 8 8v120zm40 0c0 4.418-3.578 8-8 8s-8-3.582-8-8V168c0-4.418 3.578-8 8-8s8 3.582 8 8v120zm40 0c0 4.418-3.578 8-8 8s-8-3.582-8-8V168c0-4.418 3.578-8 8-8s8 3.582 8 8v120zm40 0c0 4.418-3.578 8-8 8s-8-3.582-8-8V168c0-4.418 3.578-8 8-8s8 3.582 8 8v120zm40 0c0 4.418-3.578 8-8 8s-8-3.582-8-8V168c0-4.418 3.578-8 8-8s8 3.582 8 8v120zm40 0c0 4.418-3.578 8-8 8s-8-3.582-8-8V168c0-4.418 3.578-8 8-8s8 3.582 8 8v120zm40 0c0 4.418-3.578 8-8 8s-8-3.582-8-8V168c0-4.418 3.578-8 8-8s8 3.582 8 8v120z"
      ></path>
      <circle cx="144" cy="416" r="32" fill="#5C546A"></circle>
      <circle cx="456" cy="416" r="32" fill="#5C546A"></circle>
      <path
        fill="#8A8895"
        d="M492 108H108c-.316 0-.614.069-.924.093l-6.85-23.039C96.539 72.656 84.937 64 72.008 64l-.008.001V64H56v16h16v-.001l.008.001c5.898 0 11.195 3.953 12.875 9.613l73.242 246.348c3.032 10.188 8.988 18.919 16.632 25.696l-37.156 49.542a7.99 7.99 0 001.602 11.199 7.93 7.93 0 004.789 1.602 7.98 7.98 0 006.406-3.199l37.713-50.286c7.295 3.45 15.317 5.485 23.693 5.485H448v40c0 4.418 3.578 8 8 8s8-3.582 8-8v-40h16c4.422 0 8-3.582 8-8s-3.578-8-8-8H211.805c-17.563 0-33.328-11.762-38.336-28.602L114.184 132H492c6.625 0 12-5.371 12-12s-5.375-12-12-12z"
      ></path>
      <path
        fill="#5C546A"
        d="M56 88H16C7.163 88 0 80.837 0 72s7.163-16 16-16h40c8.837 0 16 7.163 16 16s-7.163 16-16 16z"
      ></path>
    </svg>
  );
};

export function Line() {
  const style = {
    fill: "none",
    stroke: "#fff",
    strokeWidth: "3px",
  };
  return (
    <svg
      xmlns="https://www.w3.org/2000/svg"
      width="78"
      height="3"
      viewBox="0 0 78 3"
      className="inline"
    >
      <defs></defs>
      <path style={style} d="M0 1.5h78" />
    </svg>
  );
}

export const WhatsAppButtonSvg = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 39 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className="color-element"
        cx="19.4395"
        cy="19.4395"
        r="19.4395"
        fill="#49E670"
      ></circle>
      <path
        d="M12.9821 10.1115C12.7029 10.7767 11.5862 11.442 10.7486 11.575C10.1902 11.7081 9.35269 11.8411 6.84003 10.7767C3.48981 9.44628 1.39593 6.25317 1.25634 6.12012C1.11674 5.85403 2.13001e-06 4.39053 2.13001e-06 2.92702C2.13001e-06 1.46351 0.83755 0.665231 1.11673 0.399139C1.39592 0.133046 1.8147 1.01506e-06 2.23348 1.01506e-06C2.37307 1.01506e-06 2.51267 1.01506e-06 2.65226 1.01506e-06C2.93144 1.01506e-06 3.21063 -2.02219e-06 3.35022 0.532183C3.62941 1.19741 4.32736 2.66092 4.32736 2.79397C4.46696 2.92702 4.46696 3.19311 4.32736 3.32616C4.18777 3.59225 4.18777 3.59224 3.90858 3.85834C3.76899 3.99138 3.6294 4.12443 3.48981 4.39052C3.35022 4.52357 3.21063 4.78966 3.35022 5.05576C3.48981 5.32185 4.18777 6.38622 5.16491 7.18449C6.42125 8.24886 7.39839 8.51496 7.81717 8.78105C8.09636 8.91409 8.37554 8.9141 8.65472 8.648C8.93391 8.38191 9.21309 7.98277 9.49228 7.58363C9.77146 7.31754 10.0507 7.1845 10.3298 7.31754C10.609 7.45059 12.2841 8.11582 12.5633 8.38191C12.8425 8.51496 13.1217 8.648 13.1217 8.78105C13.1217 8.78105 13.1217 9.44628 12.9821 10.1115Z"
        transform="translate(12.9597 12.9597)"
        fill="#FAFAFA"
      ></path>
      <path
        d="M0.196998 23.295L0.131434 23.4862L0.323216 23.4223L5.52771 21.6875C7.4273 22.8471 9.47325 23.4274 11.6637 23.4274C18.134 23.4274 23.4274 18.134 23.4274 11.6637C23.4274 5.19344 18.134 -0.1 11.6637 -0.1C5.19344 -0.1 -0.1 5.19344 -0.1 11.6637C-0.1 13.9996 0.624492 16.3352 1.93021 18.2398L0.196998 23.295ZM5.87658 19.8847L5.84025 19.8665L5.80154 19.8788L2.78138 20.8398L3.73978 17.9646L3.75932 17.906L3.71562 17.8623L3.43104 17.5777C2.27704 15.8437 1.55796 13.8245 1.55796 11.6637C1.55796 6.03288 6.03288 1.55796 11.6637 1.55796C17.2945 1.55796 21.7695 6.03288 21.7695 11.6637C21.7695 17.2945 17.2945 21.7695 11.6637 21.7695C9.64222 21.7695 7.76778 21.1921 6.18227 20.039L6.17557 20.0342L6.16817 20.0305L5.87658 19.8847Z"
        transform="translate(7.7758 7.77582)"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
      ></path>
    </svg>
  );
};
